import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const WishlistMenuItem = ({ count, handleKeyEsc }) => (
  <li className='txt-left p-0 m-0'>
    <div className='row mx-0 py-half '>
      <div className='col-1 py-half'>
        <i className='icon icon_wishlist color-brand-1' aria-hidden='true' />
      </div>
      <div className='col my-auto ml-1'>
        <Link
          to='/wishlist'
          className='link-wishlist link-profile txt-font-body txt-body color-no-hv d-block px-1 py-1 color-brand-1 txt-bold'
          aria-label={`Lista de favoritos, ${count} ${count === 1 ? 'item' : 'itens'} na lista`}
          onKeyDown={(e) => handleKeyEsc(e)}
        >
          Favoritos
        </Link>
      </div>
      {count > 0 && (
        <div aria-hidden className='col-auto ml-auto my-auto mr-2 wishlist-count txt-body-sm border radius-circle py-half px-1 border-color-ui-4 bg-ui-4 color-brand-1'>
          {count}
        </div>
      )}
    </div>
  </li>
)

WishlistMenuItem.propTypes = {
  count: PropTypes.number.isRequired,
  handleKeyEsc: PropTypes.func
}

WishlistMenuItem.defaultProps = {
  itemCount: 0
}

export default WishlistMenuItem



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfileSubmenu/WishlistMenuItem/WishlistMenuItem.js